export enum UserInputPanelElementEnum {
  BASIC_CREDIT_PARAMETERS = 'BASIC_CREDIT_PARAMETERS',
  BANKS = 'BANKS',
  FILTERS = 'FILTERS',
  INSURANCES = 'INSURANCES',
  SUMMARY = 'SUMMARY',
}

export const AllUserInputPanels: UserInputPanelElementEnum[] = Object.values(UserInputPanelElementEnum);
